import React from 'react'
import { CustomFormFloating } from '../../../../custom-form-floating/CustomFormFloating'
import { Link } from 'react-router-dom'
import logger from '../../../../../../utils/logger'
import { CopyButton } from './CopyButton'
import { phoneNumberFormat } from '../../../../../../helper/phoneNumberFormat'
import { div } from 'framer-motion/client'


export const UserContactData = ({ userInfo, editInput = true, emailAction = 'icon' }) => {


    logger.info('userInfo UserContactData: ', userInfo)

    return (
        <div className="user-contact">

            <div
                className='contact-container'
            >
                {userInfo?.phoneNumber &&

                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        formClass={'d-flex align-items-center'}
                        className={'editable-admin-input '}
                        label={'Teléfono:'}
                        labelClassName={'active-label'}
                        value={'3514567893'}
                    >
                        <>
                            <span className="fab fa-whatsapp mIcons-1 mI-2 mI-wp"></span>
                            <Link
                                to={`https://wa.me/${phoneNumberFormat(userInfo.phoneNumber, userInfo.phonePrefix.prefix)}`}
                                id="userPhone"
                                className="editable-a-1"
                                target='blank'
                            // onClick={(event) =>{event.preventDefault()}}
                            >
                                {phoneNumberFormat(userInfo.phoneNumber, userInfo.phonePrefix.prefix, true)}
                            </Link>
                            <label htmlFor="userPhone" className="active-label-1 class-hidden-none">Telefono:</label>
                        </>

                    </CustomFormFloating>
                }


                {userInfo?.email &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        formClass={'d-flex align-items-center'}
                        className={'editable-admin-input'}
                        label={'Email:'}
                        labelClassName={'active-label'}
                        value={'pedrodiaz@gmail.com'}
                    >

                        <>

                            {emailAction === 'icon' ?

                                <span
                                    className="material-symbols-outlined notranslate mIcons-1 mI-2"
                                    aria-hidden="true"
                                    role="none"
                                >
                                    mail
                                </span>


                                :
                                <CopyButton
                                    text={userInfo?.email}

                                />
                            }

                            <a href="" id="userEmail" className="editable-a-1">{userInfo.email}</a>
                            <label htmlFor="userEmail" className="active-label-1 class-hidden-none">Email:</label>
                        </>

                    </CustomFormFloating>

                }
            </div>



            {emailAction === 'icon' &&
                <CopyButton
                    text={userInfo?.email}

                />
            }

        </div>
    )
}
